<template>
    <div class="no_datas">
        <template v-if="!isCourse">
            <div class="content_wrap" v-if="dataExit">
                <div class="img">
                    <img src="../../assets/images/parent-course/search-nodata.png" alt="">
                </div>
                <p>暂无更多数据哦！</p>
            </div>
        </template>
        <template v-else>
            <div class="no_datas_isCourse" v-if="dataExit">
                <img class="search-nodata-iscourse" src="../../assets/images/parent-course/search-nodata-iscourse.png" alt="已购买无数据展示">
                <p class="no_datas_des">暂无购买课程</p>
                <span class="check_recommond" @click="gorecommond">查看推荐</span>
            </div>
        </template>
    </div>
</template>

<script>
export default {
  name: 'no-datas',
  components: {},
  props: {
    dataExit: {
        type: Boolean,
        default:false
    },
    isCourse: {
        type: Boolean,
        default: false
    }
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    gorecommond() {
        this.$bus.$emit('toConcerned',1)
    }
},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang="scss" scoped>
.no_datas {
    .content_wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        .img {
            width: 60%;
            height: 60%;
            img {
                width: 100%;
            }
        }
        p {
            font-size: 14px;
            color: #949C9D;
            margin-top: 11px;
        }
    }
    .no_datas_isCourse {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .search-nodata-iscourse {
            width: 140px;
            height: 120px;
        }
        .no_datas_des {
            margin-top: 20px;
            font-size: 12px;
            color: #949C9D;
            line-height: 17px;
        }
        .check_recommond {
            padding: 4px 16px;
            margin-top: 4px;
            background-color: #ddf3f7;
            border-radius: 999px;
            font-size: 14px;
            color: #0ED7E1;
        }
    }
}
</style>
